export class MenuSection {

    private optionId: string;
    private optionInternalId: string;
    private optionName: string;

    constructor(optionId?: string, optionInternalId?: string, optionName?: string) {
        this.optionId = optionId;
        this.optionInternalId = optionInternalId;
        this.optionName = optionName;
    }

    public get OptionId(): string {
        return this.optionId;
    }
    public get OptionInternalId(): string {
        return this.optionInternalId;
    }

    public get OptionName(): string {
        return this.optionName;
    }

    public set OptionId(optionId: string) {
        this.optionId = optionId;
    }

    public set OptionInternalId(optionInternalId: string) {
        this.optionInternalId = optionInternalId;
    }

    public set OptionName(optionName: string) {
        this.optionName = optionName;
    }

}
